// extracted by mini-css-extract-plugin
export default {"latest-news":"LatestNews_latest-news__n7I3+","no-data":"LatestNews_no-data__-fm5P"};